import { render, staticRenderFns } from "./MessageDeteil.vue?vue&type=template&id=0baadebd&scoped=true&"
import script from "./MessageDeteil.vue?vue&type=script&lang=ts&"
export * from "./MessageDeteil.vue?vue&type=script&lang=ts&"
import style0 from "./MessageDeteil.vue?vue&type=style&index=0&id=0baadebd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baadebd",
  null
  
)

export default component.exports